export { default } from './badge';
export type { BadgeProps, BadgeNewProps } from './types';
